export enum CommercialUnit {
  UN = 0,
  KG = 1,
  CX = 2,
  MT = 3,
  LT = 4,
  M2 = 5,
  M3 = 6
};
